import { useParams } from 'react-router-dom';

import type { FeedItemType, RouteParam } from '@/types';

import { useIsSharedFeed } from './useIsSharedFeed';
import { useQueryParams } from './useQueryParams';

const PUBLIC_CATEGORY_TABS = ['rss_news', 'exchanges'];

export const useShowOpenInSource = ({
  channelId,
  result,
}: ShowOpenInSource) => {
  const [_, queryParams] = useQueryParams();
  const { subCategory } = useParams<RouteParam>();
  const { isSharedData } = useIsSharedFeed({ isChannel: !!channelId });

  const categoryTab =
    result?.category_tab ||
    subCategory ||
    (queryParams['category_tab'] as string);

  if (result && result.source === 'needldrive') {
    if (result.upload_client === 'extension') {
      return true;
    } else {
      return false;
    }
  }

  if (categoryTab && PUBLIC_CATEGORY_TABS.includes(categoryTab)) {
    return true;
  }

  return !isSharedData;
};

type ShowOpenInSource = {
  channelId?: string;
  result?: FeedItemType;
};
